import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  menuChanged$: EventEmitter<any> = new EventEmitter();

  constructor() { }

  refreshMenu() {
    this.menuChanged$.emit();
  }
}
